import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Couriers extends Component {

  state = {
    couriers: [],
    formData: {
      id: null,
      name: "",
      slug: "",
      base_url: "",
      api_key: "",
      secret_key: "",
      store_id: "",
      username: "",
      password: "",
      grant_type: "",
      status: 1,
    },
    loading: false,
    submitting: false,
    error: "",
    modalMode: "add",
    deleteId: null,
  };

  componentDidMount() {
    this.fetchCouriers();
    const modalEl = document.getElementById("courierModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", this.resetForm);
    }
  }

  resetForm = () => {
    this.setState({
      formData: {
        id: null,
        name: "",
        slug: "",
        base_url: "",
        api_key: "",
        secret_key: "",
        store_id: "",
        username: "",
        password: "",
        grant_type: "",
        status: 1,
      },
      error: "",
      submitting: false,
      modalMode: "add",
    });
  };

  fetchCouriers = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const res = await axios.get("/couriers");
      const data = res.data?.data || [];
      // convert status to number
      const formattedData = Array.isArray(data)
        ? data.map(c => ({ ...c, status: parseInt(c.status) }))
        : [];
      this.setState({ couriers: formattedData });
    } catch (err) {
      this.setState({
        error: err.response?.data?.message || "Failed to load couriers.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };


  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: name === "status" ? parseInt(value) : value },
    }));
  };

  openModal = (mode = "add", courier = null) => {
    const modal = new window.bootstrap.Modal(document.getElementById("courierModal"));
    this.setState({
      modalMode: mode,
      formData:
        mode === "edit" && courier
          ? {
            id: courier.id,
            name: courier.name,
            slug: courier.slug,
            base_url: courier.base_url,
            api_key: courier.api_key,
            secret_key: courier.secret_key,
            store_id: courier.store_id,
            username: courier.username,
            password: courier.password,
            grant_type: courier.grant_type,
            status: parseInt(courier.status) || 0,
          }
          : { id: null, name: "", slug: "", base_url: "", api_key: "", secret_key: "", store_id: "", username: "", password: "", grant_type: "", status: 1 },
      error: "",
    });
    modal.show();
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.name || !formData.slug) {
      return this.setState({ error: "Name and Slug are required." });
    }

    this.setState({ submitting: true, error: "" });

    try {
      if (modalMode === "add") {
        await axios.post("/couriers", formData);
        Swal.fire({ icon: "success", title: "Courier added successfully!", showConfirmButton: false, timer: 1500 });
      } else {
        await axios.put(`/couriers/${formData.id}`, formData);
        Swal.fire({ icon: "success", title: "Courier updated successfully!", showConfirmButton: false, timer: 1500 });
      }

      this.fetchCouriers();
      const modal = window.bootstrap.Modal.getInstance(document.getElementById("courierModal"));
      modal.hide();
    } catch (err) {
      this.setState({
        error: err.response?.data?.message || "Failed to save courier.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(document.getElementById("deleteModal"));
    modal.show();
  };

  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      await axios.delete(`/couriers/${deleteId}`);
      this.fetchCouriers();
      const modal = window.bootstrap.Modal.getInstance(document.getElementById("deleteModal"));
      modal.hide();
      Swal.fire({ icon: "success", title: "Courier deleted successfully!", showConfirmButton: false, timer: 1500 });
    } catch {
      Swal.fire({ icon: "error", title: "Failed to delete courier." });
    }
  };

  /* ======================
     TOGGLE STATUS DIRECTLY
  ======================= */
  toggleStatus = async (id) => {
    try {
      const res = await axios.post(`/couriers/toggle/${id}`); // your CI4 route
      Swal.fire({ icon: "success", title: "Status updated!", showConfirmButton: false, timer: 1000 });
      this.fetchCouriers();
    } catch {
      Swal.fire({ icon: "error", title: "Failed to update status." });
    }
  };

  render() {
    const { couriers, formData, error, loading, submitting, modalMode } = this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5>Courier List</h5>
                  {/* <button className="btn btn-light-warning" onClick={() => this.openModal("add")}>+ New Courier</button> */}
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Slug</th>
                            <th>Base URL</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {couriers.length ? (
                            couriers.map((c, idx) => (
                              <tr key={c.id}>
                                <td>{idx + 1}</td>
                                <td>{c.name}</td>
                                <td>{c.slug}</td>
                                <td>{c.base_url}</td>
                                <td>
                                  <span
                                    className={`badge ${c.status === 1 ? "bg-success" : "bg-danger"} cursor-pointer`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => this.toggleStatus(c.id)}
                                  >
                                    {parseInt(c.status) === 1 ? "Active" : "Inactive"}
                                  </span>
                                </td>

                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() => this.openModal("edit", c)}
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>
                                  {/* <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() => this.confirmDelete(c.id)}
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button> */}
                                </td>

                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No courier found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add/Edit Modal */}
        <div className="modal fade" id="courierModal" tabIndex={-1}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">{modalMode === "add" ? "Add Courier" : "Edit Courier"}</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div className="modal-body row g-3">
                  <div className="col-md-6">
                    <label>Name</label>
                    <input type="text" name="name" className="form-control" value={formData.name} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-6">
                    <label>Slug</label>
                    <input type="text" name="slug" className="form-control" value={formData.slug} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-12">
                    <label>Base URL</label>
                    <input type="text" name="base_url" className="form-control" value={formData.base_url} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-6">
                    <label>API Key</label>
                    <input type="text" name="api_key" className="form-control" value={formData.api_key} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-6">
                    <label>Secret Key</label>
                    <input type="text" name="secret_key" className="form-control" value={formData.secret_key} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-6">
                    <label>Store ID</label>
                    <input type="text" name="store_id" className="form-control" value={formData.store_id} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-6">
                    <label>Username</label>
                    <input type="text" name="username" className="form-control" value={formData.username} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-6">
                    <label>Password</label>
                    <input type="text" name="password" className="form-control" value={formData.password} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-6">
                    <label>Grant Type</label>
                    <input type="text" name="grant_type" className="form-control" value={formData.grant_type} onChange={this.handleChange} />
                  </div>
                  <div className="col-md-6">
                    <label>Status</label>
                    <select name="status" className="form-select" value={formData.status} onChange={this.handleChange}>
                      <option value={1}>Active</option>
                      <option value={0}>Inactive</option>
                    </select>
                  </div>
                  {error && <div className="alert alert-danger mt-2">{error}</div>}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-light-danger" data-bs-dismiss="modal">Cancel</button>
                  <button type="submit" className="btn btn-light-primary" disabled={submitting}>{submitting ? "Saving..." : modalMode === "add" ? "Add" : "Update"}</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Delete Modal */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <h5>Are you sure?</h5>
                <p>This action cannot be undone.</p>
                <div className="d-flex justify-content-center gap-3">
                  <button className="btn btn-light-secondary" data-bs-dismiss="modal">Cancel</button>
                  <button className="btn btn-light-danger" onClick={this.handleDelete}>Yes, Delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Couriers;
